import { useFormik } from "formik"
import React, { useContext, useEffect, useState } from "react"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { useLocation, useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Col,
    Container,
    FormFeedback,
    Input,
    Label,
    Row
} from "reactstrap"
import * as Yup from "yup"

import { stateToHTML } from 'draft-js-export-html'

import Breadcrumbs from "components/Common/BreadcrumbTitle"

import CommonDialog from "components/Common/CommonDialog"

import { addCategoryList, getOneCategory, editCategory, getCategoryList } from "helpers/UAM/category.helper";
import { useToast } from "ToastStore";
import ToastDialog from "components/Common/ToastDialog";
import { SystemConfigurationContext } from "context/systemConfigContext"

const ViewCategory = (props) => {

    const navigate = useNavigate()

    const location = useLocation()
    const pathnameSegments = location.pathname.split("/")
    const lastSegment = pathnameSegments[pathnameSegments.length - 1]
    const {inputMax} = useContext(SystemConfigurationContext)
    let formattedLastSegment = lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).toLowerCase();
    document.title = `${formattedLastSegment} Category | DMS`

    const urlParams = new URLSearchParams(window.location.search)
    const encodedId = urlParams.get("id")
    const decodedId = atob(encodedId)

    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
    const [viewCategoryList, setViewCategoryList] = useState({})

    const [showViewCategory, setShowViewCategory] = useState(false);
    const [showEditCategory, setShowEditCategory] = useState(true);
    const [categoryList, setCategoryList] = useState([]);
    const {  handleToastData } = useToast();
    const [toastInfo, setToastInfo] = useState({ showToast: false });


    useEffect(() => {
        if (lastSegment == "view" || lastSegment == "edit") {
            getOneCategory({ id: decodedId })
                .then(responseFromAPI => {
                    if (responseFromAPI.status && responseFromAPI.code == 200) {
                        let responseData = responseFromAPI.data[0]
                        setViewCategoryList(responseData)
                    }
                })
                .catch(error => { })
        }
        if (lastSegment == "view") {
            setShowViewCategory(true)
            setShowEditCategory(false)
        } else {
            setShowViewCategory(false)
            setShowEditCategory(true)
        }

        getCategoryList()
        .then((respone)=>{
            if(respone.status && respone.code == 200){
                setCategoryList(respone?.data.data)
            }
        })
        .catch((error)=>{
      console.log(error)
        })
    }, []);

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            categoryCode: (viewCategoryList.categoryCode) || '',
            categoryName: (viewCategoryList.categoryName) || '',
            categoryDescription: (viewCategoryList.categoryDescription) || '',
            
        },
        validationSchema: Yup.object({
            categoryCode: Yup.string().required("Please Enter Your Category Code "),
            categoryName: Yup.string().required("Please Enter Your Category Name"),
            categoryDescription: Yup.string().required("Please Enter Your Category Description"),
        }),
        onSubmit: values => {

            const message = lastSegment == 'edit' ? 'Are you sure want to update category?' : 'Do you want to save entry?'
            setShowCommonDialog({ isShow: true, message: message })

        },
    })

    const navigateBack = () => {
        navigate(-1)
    }

    const dialogAction = (action, data) => {
        if (action == 1) {
            setShowCommonDialog({ isShow: false })
            upsertCategory()

        } else {

            setShowCommonDialog({ isShow: false })
        }
    }


    const upsertCategory = () => {
        const { values } = validation
       
        if (lastSegment == "edit") {
            let arr = []
            const updateCategoryData = {
                id: decodedId,
                categoryCode: values.categoryCode,
                categoryName: values.categoryName,
                categoryDescription: values.categoryDescription
            }
            arr.push(updateCategoryData)
            // update Category
            editCategory({category:arr})
                .then(responseFromAPI => {
                    if (responseFromAPI.status && responseFromAPI.code == 201) {
                        handleToastData(responseFromAPI.message, "warning")
                        navigate(`/admin/listCategory/`)
                    }else{
                        setToastInfo({
                            message: responseFromAPI.message,
                            showToast: true,
                            role: "error",
                        });
                    } 
                })
                .catch(error => { })
            validation.resetForm()
        } else {
            const newCategory = {
                categoryCode: values.categoryCode,
                categoryName: values.categoryName,
                categoryDescription: values.categoryDescription
            }
            let arr = []
            arr.push(newCategory)
            addCategoryList({category: arr})
                .then(responseFromAPI => {
                    if (responseFromAPI.status && responseFromAPI.code == 201) {
                        handleToastData(responseFromAPI.message, "success")
                        navigate(`/admin/listCategory`);

                    }else {
                        setToastInfo({
                            message: responseFromAPI.message,
                            showToast: true,
                            role: "error",
                        });
                    }
                })
                .catch(error => { })
            validation.resetForm()
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title={`${lastSegment.toUpperCase()} Category`}
                    />
                    <Row className="vertical-scroll">
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    {showEditCategory && <form
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                    >
                                        <Row className="mb-4">
                                            <Col sm={5} >
                                                <Label
                                                    htmlFor="horizontal-Category-Input"
                                                    className="col-sm-3 col-form-label"
                                                >
                                                    Category Code *
                                                </Label>
                                                <Input
                                                    maxLength={inputMax}
                                                    type="text"
                                                    className="form-control"
                                                    name="categoryCode"
                                                    id="horizontal-Category-Input"
                                                    placeholder="Enter Category Code"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.categoryCode || ""}
                                                    invalid={
                                                        validation.touched.categoryCode &&
                                                            validation.errors.categoryCode
                                                    }
                                                />
                                                {validation.touched.categoryCode &&
                                                    validation.errors.categoryCode ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.categoryCode}
                                                    </FormFeedback>
                                                ) : null}
                                            </Col>
                                            <Col sm={5}>
                                                <Label
                                                    htmlFor="horizontal-Category-Input"
                                                    className="col-sm-3 col-form-label"
                                                >
                                                    Category Name*
                                                </Label>
                                                <Input
                                                  maxLength={inputMax}
                                                    type="text"
                                                    className="form-control"
                                                    name="categoryName"
                                                    id="horizontal-Category-Input"
                                                    placeholder="Enter Category Name "
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.categoryName || ""}
                                                    invalid={
                                                        validation.touched.categoryName &&
                                                        validation.errors.categoryName
                                                    }
                                                />
                                                {validation.touched.categoryName &&
                                                    validation.errors.categoryName ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.categoryName}
                                                    </FormFeedback>
                                                ) : null}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={10} lg={10} >
                                                <Label
                                                    htmlFor="horizontal-Category-Input"
                                                    className="col-sm-6 col-form-label"
                                                >
                                                    Category Description *
                                                </Label>
                                               
                                                <Input
                                                  maxLength={inputMax}
                                                    type="textarea"
                                                    className="form-control"
                                                    name="categoryDescription"
                                                    id="horizontal-category-Input"
                                                    placeholder="Enter Category Description "
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.categoryDescription || ""}
                                                    invalid={
                                                        validation.touched.categoryDescription &&
                                                        validation.errors.categoryDescription
                                                    }
                                                />
                                               {validation.touched.categoryDescription &&
                                                    validation.errors.categoryDescription ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.categoryDescription}
                                                    </FormFeedback>
                                                ) : null}
                                            </Col>

                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="text-end" style={{ margin: "20px 17% 0px 0px" }}>
                                                <button
                                                        type="submit"
                                                        className="btn btn-success save-customer"
                                                    >
                                                        Save
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-outline-secondary"
                                                        style={{ marginLeft: "7px" }}
                                                        onClick={() => {
                                                            navigateBack();
                                                        }
                                                        }
                                                    >
                                                        Back
                                                    </button>
                                                    
                                                </div>
                                            </Col>
                                        </Row>
                                    </form>}
                                    {showViewCategory && <div>
                                        <Row>
                                            <Col sm={5}>
                                                <Label
                                                    className="col-sm-3 col-form-label label label-styling "
                                                >
                                                    Category Code
                                                </Label>
                                                <p >{viewCategoryList.categoryCode || "-"}</p>
                                            </Col>
                                            <Col sm={5}>
                                                <Label
                                                    className="col-sm-4 col-form-label label label-styling "
                                                >
                                                    Category Name
                                                </Label>
                                                <p>{viewCategoryList.categoryName || "-"}</p>
                                            </Col>
                                        </Row>
                                        <Row className="mb-4">
                                            <Col sm={10}>
                                                <Label
                                                    htmlFor="horizontal-notification-Input"
                                                    className="col-sm-3 col-form-label label label-styling "
                                                >
                                                    Category Description
                                                </Label>
                                                <p >{viewCategoryList.categoryDescription || "-"}</p>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <div>
                                                    <button
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => {
                                                            navigateBack()
                                                        }}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            {showCommonDialog &&
                <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
            }
            <ToastDialog
                message={toastInfo.message}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
            
        </React.Fragment>
    )
}

export default ViewCategory;